import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Toggle from 'react-toggle';
import getLocale from '../../i18n/getLocale';

class StaffLicensesIndex extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      situation: 0,
      licenses: [],
      am_indexes: [],
      aircraft_models_list: [],
      staff_list: [],
      date: null,
      date_start: null,
      date_finish: null,
      licence_codes: [
        {value: "CCF", label: this.locale.Habilitacoes.PesquisaDeHabilitacoes.opcoesCodigoDeHabilitacao.CCF},
        {value: "CHT", label: this.locale.Habilitacoes.PesquisaDeHabilitacoes.opcoesCodigoDeHabilitacao.CHT},
      ],
      licence_types: [
        {value: "", label: this.locale.Habilitacoes.PesquisaDeHabilitacoes.opcoesHabilitacao.SelecionarTipo},
        {value: "IFRH", label: this.locale.Habilitacoes.PesquisaDeHabilitacoes.opcoesHabilitacao.IFRH},
      ]
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.searchLicenses = this.searchLicenses.bind(this);
    this.loadData = this.loadData.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  } 
  
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
    if (this.state.date_start === "") {
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');
      this.setState({date_start: today_str});
    }
    if (this.state.date_finish === "") {
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');
      this.setState({date_finish: today_str});
    }
  }
  
  searchLicenses(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staff: this.state.staff_ids,
      code: this.state.code,
      type: this.state.type,
      situation: this.state.situation,
      aircraft_models: this.state.aircraft_models_ids,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionarios/habilitacoes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({licenses: responseJson.data.staff_licenses});
          self.setState({am_indexes: responseJson.data.am_indexes});
        }
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionarios/tripulantes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista/modelos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */  }); /* aeronave-modelo lista */
    });
  }

  exportCsv(event) {
    var url = "/exportar/pesquisa/habilitacoes";
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staff: this.state.staff_ids,
      code: this.state.code,
      type: this.state.type,
      situation: this.state.situation,
      aircraft_models: this.state.aircraft_models_ids,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      }).catch((error) => {
        console.error(error);
      });
    });  }

  
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Habilitacoes.PesquisaDeHabilitacoes.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchLicenses}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.Tripulante}:</label>
              <Select
                className=""
                name="staff_ids"
                value={this.state.staff_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                options={this.state.staff_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.ExibirTripulantesDesligados}?</label>
              <br/>
              <Toggle
                checked={this.state.situation}
                aria-label=''
                name="situation"
                onChange={this.handleToggleChange.bind(this, 'situation')} />
            </div>
          </div> 
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.Codigo}:</label>
              <Select
                className=""
                name="licence_codes"
                value={this.state.licence_code}
                searchable={true}
                placeholder={this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.placeholder.SelecionarCodigo}
                onChange={this.handleSelectChange.bind(this, 'licence_code')}
                options={this.state.licence_codes}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.Tipo}:</label>
              <Select
                className=""
                name="licence_types"
                value={this.state.licence_type}
                searchable={true}
                placeholder={this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'licence_type')}
                options={this.state.licence_types}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.VencimentoInicio}:</label>
              <DatePicker value={this.state.date_start} onChange={this.handleChangeDatePicker.bind(this, 'date_start')} className="form-control" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.VencimentoFim}:</label>
              <DatePicker value={this.state.date_finish} onChange={this.handleChangeDatePicker.bind(this, 'date_finish')} className="form-control" />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.Aeronave}:</label>
              <Select
                className=""
                name="aircraft_models_ids"
                value={this.state.aircraft_models_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'aircraft_models_ids')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.Habilitacoes.PesquisaDeHabilitacoes.formulario.botaoProcurarHabilitacoes}</button>
        </div>
      </form>
      <hr/>
      <div className="table-responsive">
        <button className="btn btn-success" value={this.state.licenses} onClick={this.exportCsv}>
          <i className="fa fa-fw fa-table"></i> {this.locale.Habilitacoes.PesquisaDeHabilitacoes.botaoExportarEmCSV}
        </button>
        <br/>
        <br/>
        <table className="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.tabela.Matricula}</th>
              <th>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.tabela.Apelido}</th>
              <th>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.tabela.CANAC}</th>
              <th>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.tabela.Licenca}</th>
              <th>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.tabela.CCF}</th>
              <th>{this.locale.Habilitacoes.PesquisaDeHabilitacoes.tabela.IFRH}</th>
              {Object.keys(self.state.am_indexes).map(function(am) {
                return (
                  <th>{self.state.am_indexes[am]}</th>
                );
              })}
            </tr>
          </thead>
          <tbody id="grupo-certificados">
            {Object.keys(self.state.licenses).map(function(k) {
              return (
                <tr>
                  <td>
                    {self.state.licenses[k].inscription}
                  </td>
                  <td>
                    {self.state.licenses[k].nickname}
                  </td>
                  <td>
                    {self.state.licenses[k].canac}
                  </td>
                  <td>
                    {self.state.licenses[k].license}
                  </td>
                  <td>
                    {self.state.licenses[k].ccf}
                  </td>
                  <td>
                    {self.state.licenses[k].ifrh}
                  </td>
                  {Object.keys(self.state.am_indexes).map(function(am) {
                    return (
                      <td>
                        {self.state.licenses[k].cht && self.state.licenses[k].cht[self.state.am_indexes[am]] && self.state.licenses[k].cht[self.state.am_indexes[am]]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default StaffLicensesIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffLicenses/StaffLicensesIndex.js